import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapturumSidebarMenuComponent } from './sidebar-menu.component';
import { RouterModule } from '@angular/router';
import { CapturumSharedModule } from '@capturum/ui/api';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    CapturumSidebarMenuComponent,
  ],
  exports: [
    CapturumSidebarMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    CapturumSharedModule,
    TooltipModule,
  ],
})
export class CapturumSidebarMenuModule {
}
